import React, { useEffect, useMemo, useState } from "react";

/**
 * NewtonAnimation
 * - uses the exact path (d) from the Newton icon
 * - computes f(x) = y_path(x) - 80 and f'(x) via segment slope
 * - shows tangent from (x_k, f(x_k)) to axis intersection (x_{k+1}, 0)
 * - endless loop through the steps
 */
const NewtonAnimation = ({ isActive }) => {
  // original path from the icon, unchanged
  const CURVE_D = `
M0.00 100.00 L0.33 98.51 L0.67 97.05 L1.00 95.61 L1.34 94.19 L1.67 92.79 L2.01 91.42 L2.34 90.08 L2.68 88.75 L3.01 87.45 L3.34 86.17 L3.68 84.91 
L4.01 83.68 L4.35 82.46 L4.68 81.27 L5.02 80.10 L5.35 78.95 L5.69 77.83 L6.02 76.72 L6.35 75.64 L6.69 74.57 L7.02 73.53 L7.36 72.50 L7.69 71.50 L8.03 70.52 L8.36 69.55 
L8.70 68.61 L9.03 67.68 L9.36 66.78 L9.70 65.89 L10.03 65.03 L10.37 64.18 L10.70 63.35 L11.04 62.54 L11.37 61.74 L11.71 60.97 L12.04 60.21 L12.37 59.47 L12.71 58.75 L13.04 
58.05 L13.38 57.36 L13.71 56.69 L14.05 56.03 L14.38 55.40 L14.72 54.78 L15.05 54.17 L15.38 53.58 L15.72 53.01 L16.05 52.45 L16.39 51.91 L16.72 51.39 L17.06 50.87 L17.39 50.38 
L17.73 49.90 L18.06 49.43 L18.39 48.98 L18.73 48.54 L19.06 48.12 L19.40 47.71 L19.73 47.31 L20.07 46.93 L20.40 46.56 L20.74 46.21 L21.07 45.86 L21.40 45.53 L21.74 45.22 L22.07 44.91 
L22.41 44.62 L22.74 44.34 L23.08 44.07 L23.41 43.82 L23.75 43.57 L24.08 43.34 L24.41 43.12 L24.75 42.90 L25.08 42.70 L25.42 42.51 L25.75 42.34 L26.09 42.17 L26.42 42.01 L26.76 41.86 
L27.09 41.72 L27.42 41.59 L27.76 41.47 L28.09 41.36 L28.43 41.26 L28.76 41.17 L29.10 41.09 L29.43 41.01 L29.77 40.94 L30.10 40.89 L30.43 40.84 L30.77 40.79 L31.10 40.76 L31.44 40.73 
L31.77 40.71 L32.11 40.70 L32.44 40.69 L32.78 40.69 L33.11 40.70 L33.44 40.71 L33.78 40.73 L34.11 40.76 L34.45 40.79 L34.78 40.83 L35.12 40.87 L35.45 40.92 L35.79 40.98 L36.12 41.03 
L36.45 41.10 L36.79 41.17 L37.12 41.24 L37.46 41.32 L37.79 41.40 L38.13 41.48 L38.46 41.57 L38.80 41.66 L39.13 41.76 L39.46 41.86 L39.80 41.96 L40.13 42.06 L40.47 42.17 L40.80 42.28 
L41.14 42.39 L41.47 42.51 L41.81 42.62 L42.14 42.74 L42.47 42.86 L42.81 42.98 L43.14 43.10 L43.48 43.23 L43.81 43.35 L44.15 43.48 L44.48 43.60 L44.82 43.73 L45.15 43.86 L45.48 43.98 
L45.82 44.11 L46.15 44.24 L46.49 44.37 L46.82 44.50 L47.16 44.63 L47.49 44.76 L47.83 44.89 L48.16 45.01 L48.49 45.14 L48.83 45.27 L49.16 45.40 L49.50 45.52 L49.83 45.65 L50.17 45.78 
L50.50 45.90 L50.84 46.02 L51.17 46.14 L51.51 46.27 L51.84 46.39 L52.17 46.50 L52.51 46.62 L52.84 46.73 L53.18 46.85 L53.51 46.96 L53.85 47.07 L54.18 47.18 L54.52 47.28 L54.85 47.38 
L55.18 47.49 L55.52 47.58 L55.85 47.68 L56.19 47.77 L56.52 47.86 L56.86 47.95 L57.19 48.04 L57.53 48.12 L57.86 48.20 L58.19 48.27 L58.53 48.35 L58.86 48.41 L59.20 48.48 L59.53 48.54 
L59.87 48.60 L60.20 48.65 L60.54 48.71 L60.87 48.75 L61.20 48.79 L61.54 48.83 L61.87 48.87 L62.21 48.90 L62.54 48.92 L62.88 48.94 L63.21 48.96 L63.55 48.97 L63.88 48.98 L64.21 48.98 
L64.55 48.98 L64.88 48.97 L65.22 48.95 L65.55 48.93 L65.89 48.91 L66.22 48.88 L66.56 48.84 L66.89 48.80 L67.22 48.75 L67.56 48.70 L67.89 48.64 L68.23 48.58 L68.56 48.50 L68.90 48.43 
L69.23 48.34 L69.57 48.25 L69.90 48.15 L70.23 48.05 L70.57 47.94 L70.90 47.82 L71.24 47.70 L71.57 47.56 L71.91 47.42 L72.24 47.28 L72.58 47.12 L72.91 46.96 L73.24 46.79 L73.58 46.62 
L73.91 46.43 L74.25 46.24 L74.58 46.04 L74.92 45.83 L75.25 45.61 L75.59 45.39 L75.92 45.16 L76.25 44.91 L76.59 44.66 L76.92 44.40 L77.26 44.14 L77.59 43.86 L77.93 43.57 L78.26 43.28 
L78.60 42.98 L78.93 42.66 L79.26 42.34 L79.60 42.01 L79.93 41.67 L80.27 41.32 L80.60 40.95 L80.94 40.58 L81.27 40.20 L81.61 39.81 L81.94 39.41 L82.27 39.00 L82.61 38.58 L82.94 38.15 
L83.28 37.71 L83.61 37.25 L83.95 36.79 L84.28 36.31 L84.62 35.83 L84.95 35.33 L85.28 34.82 L85.62 34.31 L85.95 33.78 L86.29 33.23 L86.62 32.68 L86.96 32.12 L87.29 31.54 L87.63 30.95 
L87.96 30.35 L88.29 29.74 L88.63 29.12 L88.96 28.48 L89.30 27.83 L89.63 27.17 L89.97 26.50 L90.30 25.81 L90.64 25.11 L90.97 24.40 L91.30 23.68 L91.64 22.94 L91.97 22.19 L92.31 21.42 
L92.64 20.65 L92.98 19.86 L93.31 19.05 L93.65 18.24 L93.98 17.41 L94.31 16.56 L94.65 15.70 L94.98 14.83 L95.32 13.94 L95.65 13.04 L95.99 12.13 L96.32 11.20 L96.66 10.25 
L96.99 9.30 L97.32 8.32 L97.66 7.33 L97.99 6.33 L98.33 5.31 L98.66 4.28 L99.00 3.23 L99.33 2.17 L99.67 1.09 L100.00 0.00
  `.trim();

  // extract path points (x,y) from d attribute (M/L commands)
  const pathPoints = useMemo(() => {
    const nums = CURVE_D.match(/-?\d+(\.\d+)?/g)?.map(Number) ?? [];
    const pts = [];
    for (let i = 0; i + 1 < nums.length; i += 2) {
      pts.push({ x: nums[i], y: nums[i + 1] });
    }
    // safety: sort by x
    pts.sort((a, b) => a.x - b.x);
    return pts;
  }, [CURVE_D]);

  // y(x) via linear interpolation on the polyline path
  const yOfX = (x) => {
    if (x <= pathPoints[0].x) return pathPoints[0].y;
    if (x >= pathPoints[pathPoints.length - 1].x)
      return pathPoints[pathPoints.length - 1].y;
    // binary search
    let lo = 0,
      hi = pathPoints.length - 1;
    while (hi - lo > 1) {
      const mid = (lo + hi) >> 1;
      if (pathPoints[mid].x <= x) lo = mid;
      else hi = mid;
    }
    const p0 = pathPoints[lo],
      p1 = pathPoints[hi];
    const t = (x - p0.x) / (p1.x - p0.x);
    return p0.y + t * (p1.y - p0.y);
  };

  // derivative ~ segment slope at x
  const dyDx = (x) => {
    if (x <= pathPoints[0].x + 1e-6) {
      const p0 = pathPoints[0],
        p1 = pathPoints[1];
      return (p1.y - p0.y) / (p1.x - p0.x);
    }
    if (x >= pathPoints[pathPoints.length - 1].x - 1e-6) {
      const p0 = pathPoints[pathPoints.length - 2],
        p1 = pathPoints[pathPoints.length - 1];
      return (p1.y - p0.y) / (p1.x - p0.x);
    }
    // same segment search as above
    let lo = 0,
      hi = pathPoints.length - 1;
    while (hi - lo > 1) {
      const mid = (lo + hi) >> 1;
      if (pathPoints[mid].x <= x) lo = mid;
      else hi = mid;
    }
    const p0 = pathPoints[lo],
      p1 = pathPoints[hi];
    return (p1.y - p0.y) / (p1.x - p0.x);
  };

  // Newton step in screen coordinates:
  // f(x) = y(x) - 80  =>  x_{k+1} = x_k - f/df = x_k + (80 - y)/m
  const nextX = (x) => {
    const y = yOfX(x);
    const m = dyDx(x);
    const EPS = 1e-6;
    if (Math.abs(m) < EPS) return x; // degenerate tangent case
    return x + (80 - y) / m;
  };

  // start value from the icon (circle at x=40, y=80)
  const x0 = 97.4;
  const iterations = 2;

  // Newton sequence x0..xN
  const xs = useMemo(() => {
    const arr = [x0];
    for (let i = 0; i < iterations; i++) {
      arr.push(nextX(arr[i]));
    }
    return arr;
  }, [pathPoints]); // recompute if path changes

  const points = useMemo(
    () => xs.map((x) => ({ x, y: yOfX(x) })),
    [xs]
  );

  const tangents = useMemo(() => {
    const lines = [];
    for (let i = 0; i < iterations; i++) {
      lines.push({
        x1: points[i].x,
        y1: points[i].y,
        x2: points[i + 1].x,
        y2: 80, // Achse
      });
    }
    return lines;
  }, [points]);

  // endless loop (points/tangents): 0..(2*iter+0) -> reset
  const totalSteps = iterations * 2 + 1;
  const [step, setStep] = useState(0);
  useEffect(() => {
    if (!isActive) {
      setStep(0);
      return;
    }
    const id = setInterval(() => {
      setStep((s) => (s + 1) % totalSteps);
    }, 1400);
    return () => clearInterval(id);
  }, [totalSteps, isActive]);

  const pointCount = Math.min(points.length, Math.floor(step / 2) + 1);
  const tangentIndex = step % 2 === 1 ? Math.floor(step / 2) : null;
  const verticalIndex = step > 0 && step % 2 === 0 ? step / 2 : null;

  return (
    <div className="rounded-lg overflow-hidden">
      <svg
        viewBox="0 0 100 100"
        width="100%"
        height="100%"
        style={{ backgroundColor: "#16a34a" }} // bg-green-600
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid meet"
      >
        {/* Slightly shrink outer area so nothing is cut off */}
        <g transform="translate(4,8) scale(0.9,0.8)">
          {/* Inner transform from the icon (x slightly squeezed) */}
          <g transform="translate(9,0) scale(0.8,0.9)">
            {/* x-axis at y=80 */}
            <line x1="-10" y1="80" x2="110" y2="80" stroke="#f3f4f6" strokeWidth="4" />

            {/* Curve: exact d-path */}
            <path d={CURVE_D} stroke="#f3f4f6" strokeWidth="4" fill="none" />

            {/* Tangent in current step */}
            {tangentIndex !== null && (
              <line
                x1={tangents[tangentIndex].x1}
                y1={tangents[tangentIndex].y1}
                x2={tangents[tangentIndex].x2}
                y2={tangents[tangentIndex].y2}
                stroke="#f3f4f6"
                strokeWidth="3"
                strokeDasharray="3"
              />
            )}

            {/* Vertical from x_{k+1} to the curve */}
            {verticalIndex !== null && (
              <line
                x1={points[verticalIndex].x}
                y1="80"
                x2={points[verticalIndex].x}
                y2={points[verticalIndex].y}
                stroke="#f3f4f6"
                strokeWidth="2"
                strokeDasharray="3"
              />
            )}

            {/* Points on the curve */}
            {points.slice(0, pointCount).map((p, idx) => (
              <circle key={idx} cx={p.x} cy={p.y} r="4.5" fill="#f3f4f6" />
            ))}
          </g>
        </g>
      </svg>
    </div>
  );
};

export default NewtonAnimation;
